var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRecherche = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M-1386-130H54V894h-1440z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#B2B2B2",
  stroke: "#B2B2B2",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.385 2.514c-3.94 0-7.146 3.29-7.146 7.336a7.4 7.4 0 0 0 1.337 4.269c.33.474.71.904 1.132 1.276a7.036 7.036 0 0 0 4.677 1.79c3.944 0 7.152-3.29 7.152-7.335s-3.208-7.336-7.152-7.336m0 15.16a7.521 7.521 0 0 1-5.001-1.914A7.891 7.891 0 0 1 6.75 9.85c0-4.314 3.425-7.824 7.634-7.824 4.213 0 7.64 3.51 7.64 7.824s-3.427 7.823-7.64 7.823"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.348 14.636l-5.65 5.79a.663.663 0 0 0-.001.92.626.626 0 0 0 .883.002l5.616-5.76a7.657 7.657 0 0 1-.848-.952m-5.21 7.387c-.3 0-.58-.12-.79-.336a1.155 1.155 0 0 1 0-1.601l6.06-6.21.17.244c.328.473.708.902 1.13 1.275l.192.169-5.97 6.123c-.21.217-.49.336-.791.336"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRecherche);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/recherche.e753addeac75a69df73c2f5ca17b2cbc.svg";